export enum TestDefinitionTypes {
    Group = 1,
    Single = 2,
}
